/**
 * 异步三件套统一封装（S04）：
 * loading 态 / 空态 / 错误态，页面别各写一套。
 */

import { Alert, Button, Empty, Spin } from "antd";
import type { ReactNode } from "react";
import { ApiError } from "../lib/api";

interface AsyncBoundaryProps {
  loading: boolean;
  error?: unknown;
  empty?: boolean;
  emptyText?: string;
  onRetry?: () => void;
  children: ReactNode;
}

export function AsyncBoundary({
  loading,
  error,
  empty = false,
  emptyText = "暂无数据",
  onRetry,
  children,
}: AsyncBoundaryProps) {
  if (loading) {
    return (
      <div style={{ display: "grid", placeItems: "center", padding: 64 }}>
        <Spin />
      </div>
    );
  }
  if (error) {
    const traceId = error instanceof ApiError ? error.traceId : undefined;
    const msg = error instanceof Error ? error.message : String(error);
    return (
      <Alert
        type="error"
        showIcon
        message="请求失败"
        description={
          <div>
            <div>{msg}</div>
            {traceId && (
              <div style={{ marginTop: 4, color: "#999", fontSize: 12 }}>
                traceId: {traceId}
              </div>
            )}
            {onRetry && (
              <Button size="small" style={{ marginTop: 8 }} onClick={onRetry}>
                重试
              </Button>
            )}
          </div>
        }
      />
    );
  }
  if (empty) {
    return <Empty description={emptyText} style={{ padding: 48 }} />;
  }
  return <>{children}</>;
}
